var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPricebookIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#71777C",
  d: "M17.354 28.354a.5.5 0 0 0 0-.708l-3.182-3.181a.5.5 0 1 0-.708.707L16.293 28l-2.828 2.828a.5.5 0 1 0 .707.707zM.5 0v22h1V0zM7 28.5h10v-1H7zM.5 22A6.5 6.5 0 0 0 7 28.5v-1A5.5 5.5 0 0 1 1.5 22z"
})));
export { SvgPricebookIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/pricebook-icon.23c52369.svg";